import { countries } from "@redotech/locale/countries";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { Footer } from "./footer";
import { Header } from "./header";
import { useGift } from "./use-gift";
export const Gift = memo(function Gift({ onBack }: { onBack: () => void }) {
  const {
    texts,
    inputFields,
    inputFieldInfos,
    findOrderClicked,
    findOrderDisabled,
    findOrderLoad,
  } = useGift();
  return (
    <Flex flexDirection="column" gap="3xl">
      <Header
        logo={undefined}
        merchantName={texts.merchantName}
        onBack={onBack}
        subtitle={texts.subtitle}
        title={texts.title}
      />

      <Flex flexDirection="column" gap="xl">
        <Text fontSize="md" fontWeight="semibold">
          {texts.buyerInfo}
        </Text>

        <RedoTextInput
          description={inputFieldInfos.buyerEmailOrZip.errorDescription}
          label={inputFieldInfos.buyerEmailOrZip.label}
          setValue={inputFields.inputs.buyerEmailOrZip.setValue}
          state={
            inputFieldInfos.buyerEmailOrZip.errorDescription
              ? "error"
              : undefined
          }
          value={inputFields.inputs.buyerEmailOrZip.value}
        />
        <RedoTextInput
          description={inputFieldInfos.resourceId.errorDescription}
          label={inputFieldInfos.resourceId.label}
          setValue={inputFields.inputs.resourceId.setValue}
          state={
            inputFieldInfos.resourceId.errorDescription ? "error" : undefined
          }
          value={inputFields.inputs.resourceId.value}
        />
      </Flex>
      <Flex flexDirection="column" gap="xl">
        <Text fontSize="md" fontWeight="semibold">
          {texts.yourInfo}
        </Text>
        <Flex flexDirection="row">
          <RedoTextInput
            description={inputFieldInfos.firstName.errorDescription}
            fullWidth
            label={inputFieldInfos.firstName.label}
            setValue={inputFields.inputs.firstName.setValue}
            state={
              inputFieldInfos.firstName.errorDescription ? "error" : undefined
            }
            value={inputFields.inputs.firstName.value}
          />
          <RedoTextInput
            description={inputFieldInfos.lastName.errorDescription}
            fullWidth
            label={inputFieldInfos.lastName.label}
            setValue={inputFields.inputs.lastName.setValue}
            state={
              inputFieldInfos.lastName.errorDescription ? "error" : undefined
            }
            value={inputFields.inputs.lastName.value}
          />
        </Flex>
        <RedoTextInput
          description={inputFieldInfos.email.errorDescription}
          label={inputFieldInfos.email.label}
          setValue={inputFields.inputs.email.setValue}
          state={inputFieldInfos.email.errorDescription ? "error" : undefined}
          value={inputFields.inputs.email.value}
        />
        <RedoTextInput
          description={inputFieldInfos.phoneNumber.errorDescription}
          label={inputFieldInfos.phoneNumber.label}
          setValue={inputFields.inputs.phoneNumber.setValue}
          state={
            inputFieldInfos.phoneNumber.errorDescription ? "error" : undefined
          }
          value={inputFields.inputs.phoneNumber.value}
        />
        <RedoTextInput
          description={inputFieldInfos.street1.errorDescription}
          label={inputFieldInfos.street1.label}
          setValue={inputFields.inputs.street1.setValue}
          state={inputFieldInfos.street1.errorDescription ? "error" : undefined}
          value={inputFields.inputs.street1.value}
        />
        <RedoTextInput
          description={inputFieldInfos.street2.errorDescription}
          label={inputFieldInfos.street2.label}
          setValue={inputFields.inputs.street2.setValue}
          state={inputFieldInfos.street2.errorDescription ? "error" : undefined}
          value={inputFields.inputs.street2.value}
        />
        <Flex flexDirection="row">
          <RedoTextInput
            description={inputFieldInfos.city.errorDescription}
            label={inputFieldInfos.city.label}
            setValue={inputFields.inputs.city.setValue}
            state={inputFieldInfos.city.errorDescription ? "error" : undefined}
            value={inputFields.inputs.city.value}
          />
          <RedoTextInput
            description={inputFieldInfos.state.errorDescription}
            label={inputFieldInfos.state.label}
            setValue={inputFields.inputs.state.setValue}
            state={inputFieldInfos.state.errorDescription ? "error" : undefined}
            value={inputFields.inputs.state.value}
          />
          <RedoTextInput
            description={inputFieldInfos.zip.errorDescription}
            label={inputFieldInfos.zip.label}
            setValue={inputFields.inputs.zip.setValue}
            state={inputFieldInfos.zip.errorDescription ? "error" : undefined}
            value={inputFields.inputs.zip.value}
          />
        </Flex>

        <RedoSingleSelectDropdownInput
          label={inputFieldInfos.country.label}
          options={countries.map((country) => ({
            type: "text",
            id: country.name,
            text: country.name,
            value: country.name,
          }))}
          optionSelected={function (value): void {
            inputFields.inputs.country.setValue(value.item.value);
          }}
          selectedItem={{
            type: "text",
            id: inputFields.inputs.country.value,
            text: inputFields.inputs.country.value,
            value: inputFields.inputs.country.value,
          }}
        />
      </Flex>
      <RedoButton
        disabled={findOrderDisabled}
        hierarchy="primary"
        onClick={() => findOrderClicked()}
        size="lg"
        text={texts.findOrder}
        theme="normal"
      />
      {findOrderLoad.error ? (
        <Flex align="center" flexDirection="column">
          <Text fontSize="xxs" textColor="error">
            {findOrderLoad.error?.message ||
              "Something went wrong, please try again."}
          </Text>
        </Flex>
      ) : null}
      <Footer />
    </Flex>
  );
});
